// extracted by mini-css-extract-plugin
module.exports = {"ingredientsList":"main-ingredients-list_ingredientsList__-EPTn"};